import { render, staticRenderFns } from "./CampusRankChart.vue?vue&type=template&id=f7483dd4&"
import script from "./CampusRankChart.vue?vue&type=script&lang=js&"
export * from "./CampusRankChart.vue?vue&type=script&lang=js&"
import style0 from "./CampusRankChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports